import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoadingService } from '../loading/loading.service';

/**
 * Marca una peticion como **de fondo**: no enciende el indicador global.
 *
 * Es para lo que corre sin que el usuario lo haya pedido, mientras sigue
 * escribiendo — las comprobaciones por identificacion del paso 1—. Taparle la
 * pantalla con un indicador cada vez que corrige un digito del documento seria
 * castigarlo por teclear.
 *
 * Se usa con cuentagotas: si el usuario pulso algo y espera respuesta, el
 * indicador tiene que salir.
 */
export const PETICION_DE_FONDO = new HttpContextToken<boolean>(() => false);

/**
 * Enciende el indicador de carga mientras haya peticiones en vuelo.
 *
 * `finalize` cubre las tres salidas —respuesta, error y cancelacion— asi que el
 * indicador no queda colgado cuando una llamada falla. Ese era el fallo del
 * patron anterior, donde cada componente apagaba el indicador a mano y las
 * ramas de error se lo saltaban.
 */
export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.context.get(PETICION_DE_FONDO)) return next(req);

  const liberar = inject(LoadingService).retener();
  return next(req).pipe(finalize(liberar));
};
